import {computed, onMounted, ref} from 'vue'
import {useStore} from 'vuex'
import DonationCard from '../DonationCard/DonationCard.vue'

export default {
    name: "HoldetsLys",
    props: {
        teamId: {
            type: String,
            required: false
        },
        lysposeFormUrl: {
            type: String,
            required: false
        }
    },
    components: {DonationCard},
    setup(props){
        const store = useStore()
        const teamId = computed(() => props.teamId ?? store.state.main.page_overlay_content_data.teamId)
        const lysposeFormUrl = computed(() => props.lysposeFormUrl ?? store.state.main.page_overlay_content_data.lysposeFormUrl)
        const holdetsLys = computed(() => store.state.stafet.teamLights)
        const isSubmitting = computed(() => store.state.stafet.isSubmitting)
        const skip = ref(0)
        const take = ref(50)

        onMounted(async () => {

            if (holdetsLys.value.length > 0)
                return

            store.dispatch('stafet/getTeamLights',{
                teamId: teamId.value,
                skip: skip.value,
                take: take.value
            })
        })

        const loadMore = function(){
            skip.value += take.value
            store.dispatch('stafet/getTeamLights',{
                teamId: teamId.value,
                skip: skip.value,
                take: take.value
            })
        }

        const showLoadMore = computed(()=>{
            return store.state.stafet.teamLightsTotal > holdetsLys.value.length
        })

        const getLabel = (labelKey) => {
            return store.getters['labels/getLabel']({
                labelCollection: 'HoldetsLys',
                labelKey
            })
        }

        return {
            lysposeFormUrl,
            holdetsLys,
            loadMore,
            showLoadMore,
            getLabel,
            isSubmitting
        }
    }
}